import styled from "styled-components";

interface StyledButtonLangProps {
  $color?: string;
}

const StyledButtonLang = styled.button<StyledButtonLangProps>`
  width: 60%;
  height: 70px;
  background: none;
  border: 4px solid ${(props) => props.$color || "#000000"};
  border-radius: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;

  .flag {
    width: 60px;
    height: 35px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  span {
    font-size: 24px;
    font-weight: 500;
  }
`;

export default StyledButtonLang;
